import React, { FC } from 'react';
import { Flex } from '../../Flex';
import { Text } from '../../Text';
import { IssueListComponentProps } from './IssueList.interfaces';
import './IssueListComponent.scss';

export const IssueListComponent: FC<IssueListComponentProps> = (props) => {
  const { icon, listData, errorText, handleButton, denyButton } = props;

  return (
    <div className="IssueListComponent">
      <Flex direction="column" gap="8px">
        <Flex align="center" gap="8px">
          {icon}
          <Text as="h3" color="danger" weight="bold">
            {errorText}
          </Text>
        </Flex>
        <ul className="IssueListComponent__list">
          {listData.map((course, index) => (
            <li key={`${course}/${index}`} className="IssueListComponent__row">
              <Text as="span">{course}</Text>
            </li>
          ))}
        </ul>
        {(handleButton || denyButton) && (
          <Flex justify="end" gap="8px">
            {handleButton}
            {denyButton}
          </Flex>
        )}
      </Flex>
    </div>
  );
};
